import React, {useCallback} from 'react';
import {isIE} from 'react-device-detect';

const GuardianVideo = props => {
    // eslint-disable-next-line id-length
    const onEnterOrSpaceDownHandler = useCallback(event => {
        if (event.keyCode === 13 || event.keyCode === 32) {
            props.openVideoModal(props.data, props.analyticsArgument);
        }
    }, [props]);

    const onClickHandler = useCallback(() => {
        props.openVideoModal(props.data, props.analyticsArgument);
    }, [props]);

    return (
        <div className="guardian-container">
            <p className="h3">{props.data.intro} <span>{props.data.title}</span></p>
            <article
                className="guardian-content"
                role="button"
                tabIndex="0"
                aria-labelledby={props.data.title.concat(``)}
                onClick={onClickHandler}
                onKeyDown={onEnterOrSpaceDownHandler}
            >
                <div className="guardian-video">
                    {/* TODO :: Replace baby img with guardian still and add alt tag! */}
                    {!isIE && <img src={props.data.image} alt={``} role="presentation"/>}
                    {isIE && <img
                        style={{backgroundImage: `url(${props.data.image})`, backgroundSize: `cover`, backgroundRepeat: `no-repeat`, backgroundPosition: `center`}}
                        alt={``} role="presentation"/>}
                    <img src={`/images/play-btn.png`} alt="" className="play-btn"/>
                </div>
                <div className="guardian-metadata">
                    <h2 className="h1">{props.data.headline}</h2>
                    <img src={`/images/guardian-logo.png`} alt="Guardian Logo"/>
                    <p className="subject">{props.data.subheadline}</p>
                    <p>{props.data.body}</p>
                </div>
                <div className="hover-overlay"></div>
                <p className="sr-only">play video</p>
            </article>
        </div>
    );
};

export default GuardianVideo;
